import React from 'react'

export default class Outro extends React.Component{

	onButtonClick = e => {
		let currentClassList = e.currentTarget.classList
		currentClassList.add('button--active-reverse')

		const {setScreenID} = this.props

		setTimeout(function(){ 
			setScreenID()
		}, 300)
	}

	render(){
		const {data} = this.props

		let outroData = data.outro
		const instruction = outroData.text
		const button = outroData.button

		return(
			<div className='outro'>
				<div className='instruction'>{instruction}</div>
				<div className='button button--reverse' onClick={this.onButtonClick}>{button}</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/splitScreen/subcomponents/outro.js